function getLocation(callback) {
  // const geo = new qq.maps.Geolocation('BvAln32DVnpt66zLcJGdyw9Mw2BAt24', 'wushui');
  // geo.getIpLocation(callback, (err) => {
  //   console.log(err);
  //   setTimeout(() => {
  //     getLocation(callback);
  //   }, 2000);
  // });
  // if (navigator.geolocation) {
  //   navigator.geolocation.getCurrentPosition(callback, function(fail){
  //     console.log(fail);
  //   })
  // } else {
  //   console.log('fail')
  // }
}
export default {
  // 将 base64 转换为文件
  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
      type: mime,
    });
  },
  // 校验手机号
  checkMobile(str) {
    var re = /^1(3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])\d{8}$/;
    if (re.test(str)) {
      return true;
    } else {
      return false;
    }
  },
  // 判断是否为全部为数字
  checkBankNumType(str) {
    if (str.match(/^[0-9]*$/)) {
      return true;
    } else {
      return false;
    }
  },
  // 判断字符串是否有效
  avalibleStr(str) {
    if (!str) {
      return false;
    }
    if (str == undefined) {
      // 找不到
      return false;
    }
    if (str.match(/^\s+$/)) {
      // 全是空或者全是换行
      return false;
    }
    if (str.match(/^[ ]+$/)) {
      // 全是空格
      return false;
    }
    if (str.match(/^[ ]*$/)) {
      // 全是空格或是空
      return false;
    }
    if (str.match(/^\s*$/)) {
      // 全是空/换行/空格
      return false;
    }
    return true;
  },
  /**
   * 时间戳转时间格式 yyyy/MM/DD
   */
  timeStampYMD(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    const formatNumber = (n) => {
      n = n.toString();
      return n[1] ? n : "0" + n;
    };
    return {
      year: year,
      HMS: [hour, minute, second].map(formatNumber).join(":"),
      YTD: [year, month, day].map(formatNumber).join("-"),
      fullDate: [year, month, day].map(formatNumber).join("/"),
      arrayYMD: [year, month, day], // 返回一个数组类型的 YYYY-MM-DD
    };
  },
  /**
   * 时间戳转时间格式
   */
  timeStamp(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    const formatNumber = (n) => {
      n = n.toString();
      return n[1] ? n : "0" + n;
    };
    return {
      year: year,
      HMS: [hour, minute, second].map(formatNumber).join(":"),
      YTD: [year, month, day].map(formatNumber).join("-"),
      fullDate:
        [year, month, day].map(formatNumber).join("-") +
        " " +
        [hour, minute, second].map(formatNumber).join(":"),
    };
  },
  // 根据身份证获取出生日期
  getBirthday(card) {
    var birthdayno, birthdaytemp;
    if (card.length == 18) {
      birthdayno = card.substring(6, 14);
    } else if (card.length == 15) {
      birthdaytemp = card.substring(6, 12);
      birthdayno = "19" + birthdaytemp;
    } else {
      return "";
    }
    var birthday =
      birthdayno.substring(0, 4) +
      "-" +
      birthdayno.substring(4, 6) +
      "-" +
      birthdayno.substring(6, 8);
    return birthday;
  },
  // 根据身份证获取性别
  getSex(card) {
    var sexno, sex;
    if (card.length == 18) {
      sexno = card.substring(16, 17);
    } else if (card.length == 15) {
      sexno = card.substring(14, 15);
    } else {
      return "";
    }
    var tempid = sexno % 2;
    if (tempid == 0) {
      sex = "女";
    } else {
      sex = "男";
    }
    return sex;
  },
  /**
   * 身份证号验证
   * @param {*} s
   */
  idCardValidity(code) {
    var city = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江 ",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      83: "台湾",
      91: "国外 ",
    };
    var tip = "";
    var pass = true;

    if (
      !code ||
      !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
        code
      )
    ) {
      tip = "身份证号格式错误";
      pass = false;
    } else if (!city[code.substr(0, 2)]) {
      tip = "地址编码错误";
      pass = false;
    } else {
      // 18位身份证需要验证最后一位校验位
      if (code.length === 18) {
        code = code.split("");
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        // 校验位
        var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
        var sum = 0;
        var ai = 0;
        var wi = 0;
        for (var i = 0; i < 17; i++) {
          ai = code[i];
          wi = factor[i];
          sum += ai * wi;
        }
        var last = parity[sum % 11];
        if (parity[sum % 11] != code[17]) {
          tip = "校验位错误";
          pass = false;
        }
      }
    }
    return pass;
  },
  /**
   * 时间格式化
   * @param {String} fmt 时间格式
   * @param {String | Date}} date 时间
   * @returns String
   */
  formData(fmt, date) {
    date = date ? new Date(date) : '';
    if (!date) {
      return '';
    }
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)));
    }
    return fmt;
  },
  // 获取经纬度
  getLocation,
  // 获取图片的宽和高
  getImageHeightAndWidth(imgUrl) {
    return new Promise(function (resolve, reject) {
      const image = document.createElement('img');
      image.addEventListener('load', (e) => {
        resolve({
          width: e.target.width,
          height: e.target.height
        });
      });
      image.addEventListener('error', (err) => {
        reject(err);
      });
      image.src = imgUrl;
    });
  },
  // 判断是否 是安卓
  isAndroid() {
    var u = navigator.userAgent;
    return u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  },
  // 判断是否是ios
  isiOS() {
    var u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  },
  // 防抖
  debounce(func, wait = 0) {
    if (typeof func !== 'function') {
      throw new TypeError('need a function arguments')
    }
    let timeid = null;
    let result;

    return function () {
      let context = this;
      let args = arguments;

      if (timeid) {
        clearTimeout(timeid);
      }
      timeid = setTimeout(function () {
        result = func.apply(context, args);
      }, wait);

      return result;
    }
  }
};
